import { filterLocationForPosting } from "app/components/helpers/filterLocationForPosting";
import { PostingModel } from "app/models/PostModel";
import { usePostingFormBase } from "app/utils/hooks/usePostingFormBase";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "typedefs";

interface Props {
  onPost?: (post: any) => void;
}

export const useSchedulePostingForm = ({ onPost }: Props) => {
  const { canSchedulePosts, canUploadMedia, postActions } =
    usePostingFormBase();

  const { selectedDestinations } = useSelector(
    (state: RootState) => state.destinations,
    shallowEqual,
  );

  const onSubmit = (data: PostingModel) => {
    if (selectedDestinations) {
      const filteredDestinations =
        filterLocationForPosting(selectedDestinations);

      postActions
        .createPost({ ...data, ...filteredDestinations })
        .then((res) => {
          if (res.scheduledAt && onPost) {
            onPost(res);
          }
        });
    }
  };

  return {
    canUploadMedia,
    onSubmit,
    canSchedulePosts,
  };
};
